import React from 'react'
import { MerchantLocationsLoader, LoaderSwitcher } from 'router/Loaders'
import Orders from 'components/Orders'

export const OrdersWrapper = () => {
  return (
    <MerchantLocationsLoader>
      {(isParentLoaded) => (
        <LoaderSwitcher isParentLoaded={isParentLoaded}>
          <Orders />
        </LoaderSwitcher>
      )}
    </MerchantLocationsLoader>
  )
}
